import { readCookie } from 'src/utils/Cookies';
import { Environment } from 'src/utils/Environment';
import { useSalesChannel } from '../SalesChannel/SalesChannel';

export const setDefaultReseller = (referralId?: string, referralIdDev?: string) => {
  const { setTrackingHost } = useSalesChannel();
  const isDev = Environment.current.isDev;

  if (readCookie('referralId')) return;

  if (isDev && referralIdDev) {
    setTrackingHost(referralIdDev);
  }

  if (!isDev && referralId) {
    setTrackingHost(referralId);
  }
};
